var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroundtruthLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 32,
    viewBox: "0 0 22 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2672 18.7189H12.4392V12.5749H19.2792C18.6648 17.1637 15.5112 22.4461 11.208 27.8125C6.49676 21.8725 3.17996 16.0141 3.17996 11.0989C3.17996 6.63489 6.70316 2.94609 11.208 2.94609C14.28 2.94609 16.7784 4.54209 18.2136 6.96129L20.1792 5.77329C18.3768 2.66049 15.1008 0.69249 11.208 0.69249C5.47436 0.69249 0.803955 5.32209 0.803955 11.0965C0.803955 16.8709 5.10475 24.2461 11.208 31.2925C17.3112 24.2461 21.612 16.9957 21.612 11.0965V10.4005H10.2648V18.7165L10.2672 18.7189Z",
    fill: "#151E24"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundtruthLogo);
export default __webpack_public_path__ + "static/media/groundtruth-logo.88310a454c2d2770cc0c54072f1e7e4f.svg";
export { ForwardRef as ReactComponent };